import React from 'react';

export const ColorSwatches = ({ colors, value, onChange, size = 24 }) => (
  <div style={{ display: 'flex', gap: 4, alignItems: 'center' }}>
    {colors.map(hex => (
      <button key={hex} onClick={() => onChange(hex)} style={{
        width: size, height: size, borderRadius: 6, background: hex,
        border: value === hex ? '3px solid #111827' : '2px solid rgba(0,0,0,0.15)',
        cursor: 'pointer', padding: 0,
      }} />
    ))}
  </div>
);

/**
 * Shared StyleToggle used by RouteTool and AnnotationMarkers.
 * value: 'solid' | 'dashed' | 'dotted'
 */
export const StyleToggle = ({ value, onChange, label = 'Style' }) => (
  <div style={{ marginBottom: 14 }}>
    <div style={{ fontSize: 11, fontWeight: 600, color: '#1f2937', marginBottom: 6 }}>{label}</div>
    <div style={{ display: 'flex', gap: 4 }}>
      {['Solid', 'Dashed', 'Dotted'].map(s => {
        const v = s.toLowerCase();
        return (
          <button key={v} onClick={() => onChange(v)} style={{
            flex: 1, padding: '5px 0', borderRadius: 6, fontSize: 12, cursor: 'pointer',
            fontWeight: value === v ? 600 : 400,
            background: value === v ? '#0d3825' : 'white',
            color: value === v ? 'white' : '#374151',
            border: value === v ? '1px solid #0d3825' : '1px solid #d1d5db',
          }}>
            {s}
          </button>
        );
      })}
    </div>
  </div>
);

/** Escape a string for safe injection into HTML attribute/text contexts. */
export const escapeHtml = (str) => {
  if (!str) return '';
  return String(str)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');
};
